module.exports = __webpack_public_path__ + "img/MarchingSquares.84fcd356.png";